import { render, staticRenderFns } from "@/manager/billing/views/edit-bill-modal/shopping-cart/shopping-cart.pug?vue&type=template&id=77245e6a&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=77245e6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77245e6a",
  null
  
)

export default component.exports